import gql from 'graphql-tag';

export default gql`
    query GetLoadListCSV($input: GetLoadsCSVInput) {
        getLoadListCSV(input: $input) {
            csv
        }
    }
`;
